/// <reference path='../_all.ts' />

module navigation {
  'use strict';

  var HYSTERESIS : number = 200; //the top and bottom of the active element will be increased by 25pixel, to prevent flickering

  export const enum ElementType  {
    Page              = 0,
    Block             = 1,
    Query             = 2,
    Placeholder       = 3,
  }

  /**
   * Services that changes the url according to elements in viewport.
   * AnchorNavDirective adds Elements, and this Service changes the location path, according to the Element currently in the viewport.
   */
  export class AnchorNavService implements IAnchorNavService {

    //private elements: { [key: string] : HTMLElement; } = {};    

    
    
    private elements: AnchorNavItem[] = [];
    private activeElement: AnchorNavItem;
    private activeHashElement: AnchorNavItem;
    private currentHash: string = '';
    private topPath: AnchorNavItem;
    private lastDocumentHeight : number = 0;
    private topOffset:number = 0;
    private changeLocation : () => void;
    private scrollToLocation : () => void;
    private isScrolling : boolean;

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$window', 
      '$location',
      '$timeout',
      '$http', 
      '$q',
      'debounce',
      'CacheFactory',
      'parallaxService',
      '$analytics',
    ];

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $window: ng.IWindowService,
      private $location: ng.ILocationService,
      private $timeout: ng.ITimeoutService,
      private $http: ng.IHttpService,
      private $q: ng.IQService,
      private debounce:  navigation.IDebounceService,
      private CacheFactory: CacheFactory.ICacheFactory,
      private parallaxService: navigation.IParallaxService,
      private $analytics : angulartics.IAnalyticsService
      ) {

      
      if (!CacheFactory.get('dataCache')) {
        CacheFactory.createCache('dataCache', {
          storageMode: 'sessionStorage', // This cache will use `sessionStorage`.
        });
      }
      
      this.topOffset = $(window).height() / 6; //postion element on first xth

      //top = no path
      this.topPath = new AnchorNavItem (pglob.RouteData.BasePageUrl, null, 0, 0);
      this.elements.push(this.topPath);

      $timeout(() => {
        $analytics.pageTrack(pglob.RouteData.CurrentLanguage.hlPrefix + $location.url(), $location);
      });
        
      $rootScope.$on('$locationChangeStart', (event, next, current) => {   
        if (next == current) return;
        if (next == "") return;

        //console.log("NEXT:" + next + "; CURRENT:" + current);

        if (pglob.RouteData.BasePageId == "04-1_Glossar_show") $window.location.href = next; //haaaak
         
        if (this.topPath.isAtStartOf($location.path())) { //inside this page
          $analytics.pageTrack(pglob.RouteData.CurrentLanguage.hlPrefix + $location.url(), $location);
          return;
        }

        this.getNavigationData().then((data : MenuNode[]) => {
          var re : IRouteEntry = this.findByUrl(data, $location.path());
          if (re) {
            //if base page is not the same we can not do it the ajax way.

            var stack = angular.copy(re.RouteParameterStack);
            while(stack.length > 0 && stack[0].PageType != ElementType.Page) {
              stack.shift();
            }
             
            if (stack.length == 0 || stack[0].PageId != pglob.RouteData.BasePageId) $window.location.href = next; //we need a page refresh, so we'll use the href attribute.
            this.updateRouteParameters(re, true, data); 
          } else {
            $window.location.href = next;
            $analytics.pageTrack(pglob.RouteData.CurrentLanguage.hlPrefix + $location.url(), $location);
          }
        });
        
      });


      var onScroll = (event : ng.IAngularEvent, scrollTop : number) => {
        if (this.isScrolling) return;

        //the height has changed (tabs, dynamic content) we have to do a recalulation.
        if (this.lastDocumentHeight != $(document).height()) {
          this.reCalc();
          this.lastDocumentHeight = $(document).height();
        }

        var scrollTop = scrollTop + this.topOffset;
        
        var lastActiveElement : AnchorNavItem = this.topPath;

        for(var i = 0; i < this.elements.length; i++) {
          var ani : AnchorNavItem = this.elements[i];
          if (ani.isActive && !ani.isActive()) continue; //has function and function isActive not return true (tabs and sorts)
          if (!$(ani.element).is(':visible')) continue;

          var top = ani.top;
          if (this.activeElement == ani) top -= HYSTERESIS;
          
          if (top < scrollTop) {
            lastActiveElement = ani;
          } else {
            this.setActive(lastActiveElement);
            return;
          }
        }

        this.setActive(lastActiveElement); 
      };




      this.changeLocation = () => {

        this.$rootScope.$apply(() => {

          var path : string = null;
          var hash : any = null;

          if (this.activeElement == null) {
            path = this.topPath.key;
          } else {
            path = this.topPath.key;
            if (this.topPath !== this.activeElement) {
              path = path + this.activeElement.key;
            }
          }

          if (this.activeHashElement == null) {
            hash = {};
          } else {
            hash = {}
            hash[this.activeHashElement.key.replace("?", "")] = true;
          }

          // key any query parameter that are not boolean
          if (this.$location.search()) {
            for (var k in this.$location.search()) {
              var v = this.$location.search()[k];
              if (typeof v !== "boolean") {
                hash[k] = v;
              }
            }
          }

          this.$location.path(path).search(hash).replace();  
          
       });
      }

      var localScrollToLocation = () => {
        if (this.lastDocumentHeight != $(document).height()) {
          this.reCalc();
          this.lastDocumentHeight = $(document).height();
        }

        var active = this.activeHashElement || this.activeElement;

        if (!active) return;

        console.log(active.key + " => " + active.top);
        this.isScrolling = true;

        var options = {
          afterScroll: () => {
            if (this.lastDocumentHeight != $(document).height()) {
              this.reCalc();
              this.lastDocumentHeight = $(document).height();
              this.scrollToLocation();
            } else {
              this.isScrolling = false;
            }
          },
        };

        (<any>$).smoothScroll(options,  Math.round(active.top - this.topOffset))

      }

      this.changeLocation = debounce(this.changeLocation, 800, false);
      this.debouncedReCalc = debounce(this.reCalc, 100, false);
      
      //empty funtion while loading
      this.scrollToLocation = function(){};
      angular.element(document).ready(() => {
        this.scrollToLocation = debounce(localScrollToLocation, 300, false);
        $timeout(() => {
          this.scrollToLocation();
        }, 0);
      });
      this.parallaxService.subscribeOnScroll($rootScope, onScroll);
    }
    
    //current path
    public getPath():string{
      return this.$location.path();
    }

    //current local part of the path: 
    //"/de/Home/Referenzen/Verkehr-Umwelt" will return "Verkehr-Umwelt"
    public getLocalRelativePathPart():string {
      var path = this.$location.path();
      path = path.replace(pglob.RouteData.CurrentLanguage.hlPrefix, "");
      path = path.replace(this.topPath.key, "");
      return path;
    }
    
    //current local part of the path the page was loaded with: 
    //"/de/Home/Referenzen/Verkehr-Umwelt" will return "Verkehr-Umwelt"
    public getRequestLocalRelativePathPart() : string {      
      return pglob.RouteData.RouteEntry.UrlByLanguage[pglob.RouteData.CurrentLanguage.hlFull].replace(pglob.RouteData.CurrentLanguage.hlPrefix + this.topPath.key, "")
    } 

    public addElement(key: string, el: HTMLElement, active?: () => boolean, useInScrollNav? : boolean, title? : string) : AnchorNavItem {
      var obj = new AnchorNavItem (key, el, 0, 0, active, useInScrollNav, title);

      //add new object
      this.elements.push(obj);
      this.debouncedReCalc();
     
      //is it the element selected by the url?
      if (obj.key.substr(0,1) == '?' && obj.compareQuery(this.$location.search())) {
        this.activeHashElement = obj;
        this.scrollToLocation();
      } else if (obj.compareKey(this.$location.path())){
        this.activeElement = obj;
        this.scrollToLocation();
      } else if (obj.compareKey(this.getRequestLocalRelativePathPart())){
        this.activeElement = obj;
        this.scrollToLocation();
      }

      
      return obj;
    }

    public setActive(nsi: AnchorNavItem) : void {
      if (nsi == this.activeElement) return; //already here.
      if (this.activeElement && this.activeElement.key.indexOf(nsi.key) == 0) return; //tab child active.

      if (nsi.key.substr(0,1) == '?') {
        this.activeHashElement = nsi;
      } else {
        this.activeElement = nsi;
      }

      this.changeLocation();      
    }

    public setInactive(nsi: AnchorNavItem):void {
      if (nsi.key.substr(0,1) == '?') {
        this.activeHashElement = null;
      } else {
        this.activeElement = null;
      }
      this.changeLocation();   
    }


    public setTopLocation(path : string):void {
      this.topPath.key = path;
    }

    private debouncedReCalc : () => void; //platzhalter für eine debounced version der unteren

    private reCalc():void {
      this.elements.forEach((el: AnchorNavItem, index:number, array : AnchorNavItem[]):void => {
        if (el.element == null) return; //root
        var element : JQuery = $(el.element);
        var topPos = element.offset().top
          - parseInt(element.css("border-top-width"))
          - parseInt(element.css("margin-top"));
        el.top = topPos;
      });

      this.elements.sort(function (a : AnchorNavItem, b : AnchorNavItem):number {
        return a.top - b.top;
      })

      //top of next = bottom of previous
      for(var i = 0; i < this.elements.length - 1; i++ ) {
        this.elements[i].bottom = this.elements[i+1].top;
      }
      this.elements[this.elements.length - 1].bottom = this.elements[this.elements.length - 1].top + $(this.elements[this.elements.length - 1].element).height();

    }

    private getBaseUrl(re : IRouteEntry, menuData : MenuNode[]) : string {
      var stack = angular.copy(re.RouteParameterStack);
      while(stack.length > 0 && stack[0].PageType != ElementType.Page) {
        stack.shift();
      }
      if (stack.length == 0) return null;
      var re = this.findByRoutParameter(menuData, stack);
      if (!re) return null;
      return re.UrlByLanguage[pglob.RouteData.CurrentLanguage.hlFull];
    }


    /**
     * Updates the Documents location and emits a location Changed event which can be subscribed with subscribeOnLocationChanged
     * @param re the routing with the desired new url and paramater stack.
     */
    public updateRouteParameters(re : IRouteEntry, newBase? : boolean, menuData? : MenuNode[]) :void{ 
      if (!menuData) this.getNavigationData().then((data : MenuNode[]) => { this.updateRouteParameters(re, newBase, data); });
      if (!newBase) this.$location.replace();
      
      var url = re.UrlByLanguage[pglob.RouteData.CurrentLanguage.hlFull];
      if (url.indexOf(pglob.RouteData.CurrentLanguage.hlPrefix + "/") == 0) url = url.replace(pglob.RouteData.CurrentLanguage.hlPrefix, '');

      if (this.topPath.compareKey(url)) return; //no change
      
      var baseUrl = url;
      if (re.RouteParameterStack[0].PageType != ElementType.Page) {
        var newBaseUrl : string = this.getBaseUrl(re, menuData);
        if (newBaseUrl) {
          if (newBaseUrl.indexOf(pglob.RouteData.CurrentLanguage.hlPrefix + "/") == 0) newBaseUrl = newBaseUrl.replace(pglob.RouteData.CurrentLanguage.hlPrefix, '');
          baseUrl = newBaseUrl;
        }
      }

      if (newBase) pglob.RouteData.BasePageUrl = this.topPath.key = baseUrl;
      if (!newBase) url = this.topPath.key + url;
      
      pglob.RouteData.RouteEntry = re;
      this.setTopLocation(baseUrl);
      this.$location.path(url);
      this.$rootScope.$emit('location-changed', re);
    }

    public subscribeOnLocationChanged(
      scope : ng.IScope
      , callback: (event: ng.IAngularEvent, re : IRouteEntry) => void
      ) : void {
      var handler = this.$rootScope.$on('location-changed', callback);
      if (scope) scope.$on('$destroy', handler);
    }

    
    public getNavigationData() : ng.IPromise<MenuNode[]> {
      var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Navigation?parentPageId=00-menu-base"

      var deferred = this.$q.defer<MenuNode[]>();
      var start = new Date().getTime();
      var dataCache = this.CacheFactory.get('dataCache');

      //in cache?
      if (dataCache.get(url) && angular.isArray(dataCache.get(url))) {
        deferred.resolve(dataCache.get(url));
        return deferred.promise;
      } 

      //embeded in html?
      var dataEl = document.getElementById('navigation-data');
      if (dataEl) {
        var data : MenuNode[] = JSON.parse(dataEl.innerHTML);
        dataCache.put(url, data);
        deferred.resolve(data);
        return deferred.promise;
      }

      //fetch from network?
      this.$http<MenuNode[]>({
          method: "GET"
        , url: url
        , headers: { 'Content-Type': 'application/json' }
      }).then((response : { data : MenuNode[]}) :any => { //success
        console.log('time taken for request: ' + (new Date().getTime() - start) + 'ms');
        dataCache.put(url, response.data);
        deferred.resolve(response.data);
      });   
      
      return deferred.promise;   

    }

    public findAndMarkCurrentNode(nodes : MenuNode[]) {
      var n : MenuNode = this.findL1Node(nodes, pglob.RouteData.BasePageId);
      if (!n) return;
      n.IsCurrent = true;

      var rpvs : IRouteParameter[] = angular.copy(pglob.RouteData.RouteEntry.RouteParameterStack);
      var rpv = rpvs.pop();
      while (rpv) {
        n = this.findById(n, rpv.Id, rpv.PageId);      
        if (!n) return
        n.IsCurrent = true;
        rpv = rpvs.pop();
      }
    }

    public findL1Node(nodes : MenuNode[], pageId : string) : MenuNode {
      var rootNode : MenuNode[] = nodes.filter((n:MenuNode) : boolean => {
        if (n.PageId == pageId) {
          return true;
        } else {
          return this.findL1Node(n.Nodes, pageId) != null;
        };
      });
      if (rootNode.length > 0) {
        return rootNode[0];
      } else {
        return null;
      }
    }

    public findById(node : MenuNode, id : string|number, pageid? : string) : MenuNode {
      var rootNode : MenuNode = null;
      var queue : MenuNode[] = [];
      queue.push(node);
      while (queue.length > 0) {
        var rootNode = queue.shift();
        if (pageid && pageid == rootNode.PageId && rootNode.Id == id) return rootNode;
        if (!pageid && rootNode.Id == id) return rootNode;
        rootNode.Nodes.forEach((value) => { queue.push(value); });
      }
      return null;
    }

    //public getBaseHref() {
    //  var href = $(document).find('base').attr('href');
    //  return href ? href.replace(/^(https?\:)?\/\/[^\/]*/, '') : '';
    //};
      

    private findByUrl(node : MenuNode[], url : string) : IRouteEntry {
      
      var rootNode : MenuNode = null;
      var queue : MenuNode[] = [];
      node.forEach((value) => {
        queue.push(value)
      });

      var base : string = pglob.RouteData.CurrentLanguage.hlPrefix + url;
      base = base.toLowerCase();
      
      while (queue.length > 0) {
        var rootNode : MenuNode = queue.shift();
        var found : boolean = false;
        angular.forEach(rootNode.RouteEntry.UrlByLanguage, (value : string, key : string) => {
          if (value && base == value.toLowerCase()) found = true;
        });
        if (found) return rootNode.RouteEntry;
        rootNode.Nodes.forEach((value) => { queue.push(value); });
      }
      return null;
    }

    private findByRoutParameter(node : MenuNode[], rpv : IRouteParameter[]) : IRouteEntry {
      
      var rootNode : MenuNode = null;
      var queue : MenuNode[] = [];
      node.forEach((value) => {
        queue.push(value)
      });

      while (queue.length > 0) {
        var rootNode : MenuNode = queue.shift();
        var found = this.compareStack(rootNode.RouteEntry.RouteParameterStack, rpv);
        if (found) return rootNode.RouteEntry;
        rootNode.Nodes.forEach((value) => { queue.push(value); });
      }
      return null;
    }

    private compareStack(rpv1 : IRouteParameter[], rpv2 : IRouteParameter[]) : boolean {
      if (rpv1.length != rpv2.length)  return false;

      for(var i = 0; i < rpv1.length; i++) {

        if (rpv1[i].PageId != rpv2[i].PageId
          || rpv1[i].Placeholder != rpv2[i].Placeholder
          || rpv1[i].Id != rpv2[i].Id){
          
          return false;  
        }
      }

      return true;
    }

    public resetActivePath(rootNodes : MenuNode[]) : void {
      var n : MenuNode[] = this.getActivePath(rootNodes);
      n.forEach((value : MenuNode) => {
        value.IsCurrent = false;
      });
    }
    
    /**
     * Returns the path in the menu, marked with IsCurrent, e.g. Products - Turbiditymeters - LabScat 2
     * @param rootNodes       Set of root nodes to start the search.
     * @param nodeToGetPath   target node to search.
     * @returns               Array with the MenuNodes that lead to this node, most specific Node first, e.g. LabScat 2 - Turbiditymeters - Products.
     */
    public getActivePath(rootNodes : MenuNode[]) : MenuNode[] {
      var activeNodes : MenuNode[] = [];
      var queue : MenuNode[] = [];
      rootNodes.forEach((value) => { queue.push(value); });
      while (queue.length > 0) {
        var n = queue.shift();
        if (n.IsCurrent) {
          activeNodes.push(n);
          queue = [];
        }
        n.Nodes.forEach((value) => { queue.push(value); });
      }
      return activeNodes.reverse();
    }


    /**
     * Returns all MenuNodes that lead to a ceratain MenuNode, e.g. Products - Turbiditymeters - LabScat 2
     * @param rootNodes       Set of root nodes to start the search.
     * @param nodeToGetPath   target node to search.
     * @returns               Array with the MenuNodes that lead to this node, most specific Node first, e.g. LabScat 2 - Turbiditymeters - Products.
     */
    public getMenuTreePath(rootNodes : MenuNode[], nodeToGetPath : MenuNode) : MenuNode[] {
      for(var i : number = 0; i < rootNodes.length; i++) {
        if (rootNodes[i] == nodeToGetPath) {
          return [rootNodes[i]];
        }
        var n = this.getMenuTreePath(rootNodes[i].Nodes, nodeToGetPath);
        if (n) {
          n.push(rootNodes[i]);
          return n;
        }
      }
    }

    
    
    getElements() : AnchorNavItem[] {
      return this.elements;
    }
    
    scrollTo(key : string) {
      var active = this.elements.filter((ani) => {
        return ani.key == key;
      });
      if (active.length > 0) {
        if (active[0].key.substr(0,1) == '?') {
          this.activeHashElement = active[0];
        } else {
          this.activeElement = active[0];
          this.activeHashElement = null;
        }
        this.scrollToLocation();
        this.changeLocation();      
      }
    }

    getActiveNavItem() : AnchorNavItem {
      return this.activeElement;
    }


    /**
      * mirror location search function in this service
      */
    search(): any;
    search(search: any): ng.ILocationService;
    search(search: string, paramValue: string|number|string[]|boolean): ng.ILocationService;

    public search(search?: string, paramValue?: string|number|string[]|boolean): ng.ILocationService { 
      if (search && paramValue) return this.$location.search(search, paramValue);
      if (search) return this.$location.search(search);
      return this.$location.search();
    } 


    public getQueryValue(parameterName : string) : any {
      var query = this.search();

      for (var key in query) {
        if (key.toLowerCase() === parameterName.toLowerCase()) {
          var val = this.search()[key];
          if (key !== parameterName) { //change case
            delete query[key];
            query[parameterName] = val;
            this.search(query);
          }
          return this.search()[parameterName];
        }
      }

      return null;
    }
    
  }
}